// extracted by mini-css-extract-plugin
var _1 = "CourseModal_closeFix__5c24e";
var _2 = "CourseModal_content__677eb";
var _3 = "CourseModal_contentWrapper__d2317";
var _4 = "CourseModal_desktop__fc633";
var _5 = "CourseModal_mobile__0b8f0";
var _6 = "CourseModal_overlay__2281f";
var _7 = "CourseModal_root__68add";
var _8 = "CourseModal_tablet__aa73c";
export { _1 as "closeFix", _2 as "content", _3 as "contentWrapper", _4 as "desktop", _5 as "mobile", _6 as "overlay", _7 as "root", _8 as "tablet" }
